import type { CalculatorId, CalculatorQuoteDraft } from "./types";

export type CalculatorRevisions = Record<CalculatorId, number>;
export type CalculatorDraftCache = Partial<Record<CalculatorId, CalculatorQuoteDraft>>;

export const INITIAL_CALCULATOR_REVISIONS: CalculatorRevisions = {
  digital: 0,
  vinyl: 0,
  offset: 0,
};

export function clearCalculatorDrafts(cache: CalculatorDraftCache, modes: CalculatorId[]): CalculatorDraftCache {
  const next = { ...cache };
  for (const mode of new Set(modes)) delete next[mode];
  return next;
}

export function advanceCalculatorRevisions(revisions: CalculatorRevisions, modes: CalculatorId[]): CalculatorRevisions {
  const next = { ...revisions };
  for (const mode of new Set(modes)) next[mode] += 1;
  return next;
}
